import { Injectable, Injector } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, Subscription, throwError } from 'rxjs';
import { catchError, retry, tap } from 'rxjs/operators';

import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthenticationService } from 'projects/shared/src/services/authentication.service';
import { SwalService } from '../services/swal.service';
import { MatDialog } from '@angular/material/dialog';
import Swal from 'sweetalert2';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  lang = localStorage.getItem('language') || 'ar';
  subscriptions: Subscription[] = [];
  constructor(
    private injector: Injector,
    private authenticationService: AuthenticationService,
    private router: Router,
    private snackBar: MatSnackBar,
    public dialog: MatDialog
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      // retry({ count: 4, delay: 10000 }),
      catchError(err => {
        if (err.status === 425) {
          this.dialog.closeAll();
          this.authenticationService.logout();
        }
        if (this.authenticationService.currentUserValue) {
          if (err.status === 424 || err.status === 423 || err.status === 403) {
            this.dialog.closeAll();
            // this.authenticationService.logout();
            this.router.navigate(['/notAuthorized']);
          }
          if (err.status === 401 || err.status === 422) {
            if (!this.subscriptions.length) {
              this.subscriptions.push(
                this.authenticationService.RefeshUserToken().subscribe(data => {
                  this.subscriptions = [];
                  // Swal.close();
                }, err => {
                  this.dialog.closeAll();
                  this.authenticationService.logout();
                  Swal.close();
                  this.subscriptions = [];
                })
              );
            }
            // this.authenticationService.RefeshUserToken().subscribe((data: any) => {
            // }, (err: any) => {
            //   this.dialog.closeAll();
            //   this.authenticationService.logout();
            // });
          }
          if (err.status === 450) {
            this.dialog.closeAll();
            Swal.fire({
              title: err.error,
              text: '',
              icon: 'error',
              confirmButtonText: this.lang == 'en' ? 'View Plan Details' : 'عرض تفاصيل الباقة',
              showCancelButton: true,
              cancelButtonText: this.lang == 'en' ? 'OK' : 'حسنا',
            }).then(result => {
              if (result.isConfirmed) {
                this.router.navigate(['/consumer/user-profile'], {
                  queryParams: { showSubscriptionDetails: true }
                });
              }
            });
          }
        }
        if (err.status === 0) { // Offline
          this.snackBar.open(
            this.lang == 'en' ? 'You are offline!' : 'أنت غير متصل!',
            this.lang == 'en' ? 'Ok' : 'حسنا',
            {
              horizontalPosition: 'center',
              verticalPosition: 'top'
            });
          // this.snackBar.open(this.translate.instant('general.You are offline!'), this.translate.instant('swalMsg.Ok'), {
          //   horizontalPosition: 'center',
          //   verticalPosition: 'top'
          // });
        }

        // Show Swal only for GET requests
        if (
          request.method === 'GET' && err.status !== 450 &&
          err.error
        ) {
          this.handleErrors(err.error);
        }

        // const error = err.error.message || err.statusText;
        return throwError(err.error);
      })
    );
  }

  private handleErrors(errors: any): void {
    try {
      let result = typeof errors === 'string'
        ? JSON.parse(errors)
        : errors;

      // ASP.NET ProblemDetails response
      if (result?.detail) {
        result = typeof result.detail === 'string'
          ? JSON.parse(result.detail)
          : result.detail;
      }

      if (result?.ErrorDTO && Array.isArray(result.ErrorDTO)) {
        Swal.close();
        result.ErrorDTO.forEach((error: any) => {
          this.swalService.swalFailed(error.Error);
        });
      }

    } catch (e) {
      console.error('Error parsing response', e);
    }
  }

  private get swalService(): SwalService {
    return this.injector.get(SwalService);
  }
}
